// extracted by mini-css-extract-plugin
export default {"position":"p21mn","positionTopBlocks":"jqIvD","positionMidBlocks":"E9QH9","positionBottomBlocks":"vS2No","rowSpacing":"UmOEr","positionBlock":"lnCyG"};